import * as ng from 'angular';
import { BaseUrlService } from '../../../services/base-url.service';
import { ArchiSmallServices } from '../../../services/archismall.service';


class UnsubscriptionIndexController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'ArchiSmallServices',
        'store',
        '$filter',
        'BaseUrlService'
    ];
    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private ArchiSmallServices: ArchiSmallServices,
        private store: ng.a0.storage.IStoreService,
        private $filter: ng.IFilterService,
        private _baseService: BaseUrlService
    ) {
        /* tslint:disable:no-string-literal */
        //
        ArchiSmallServices.getUser($rootScope.currentUser().sub).then((response) => {
            $scope.user = response;
            store.set('user', $scope.user);
            if ($scope.user.subscription.subscriptionCancelled) {
                $rootScope.unsubscriptionModeAvailabilityDateMilliseconds = $scope.user.subscription.subscriptionCancelledDate + $rootScope.getMillisecondsFromDays(45);
                $rootScope.unsubscriptionModeAvailabilityDate = $filter('date')($rootScope.unsubscriptionModeAvailabilityDateMilliseconds, 'dd/MM/yy');

                let dateDifferenceInMilliseconds = $rootScope.unsubscriptionModeAvailabilityDateMilliseconds - new Date().getTime();
                $rootScope.hoursUntilUnsubscriptionModeExpires = {};
                if (dateDifferenceInMilliseconds < 0) {
                    $rootScope.hoursUntilUnsubscriptionModeExpires['remainingDays'] = 0;
                    $rootScope.hoursUntilUnsubscriptionModeExpires['remainingHours'] = 0;
                } else {
                    let dayMilliseconds = 24 * 60 * 60 * 1000;
                    let hourMilliseconds = 60 * 60 * 1000;
                    let remainingDays = Math.floor(dateDifferenceInMilliseconds / dayMilliseconds);

                    let remainingHours = (dateDifferenceInMilliseconds - remainingDays * dayMilliseconds) / hourMilliseconds;

                    if (remainingHours < 1) {
                        remainingHours = Math.ceil(remainingHours);
                    } else if (remainingHours > 1) {
                        remainingHours = Math.floor(remainingHours);
                    }

                    $rootScope.hoursUntilUnsubscriptionModeExpires['remainingDays'] = remainingDays;
                    $rootScope.hoursUntilUnsubscriptionModeExpires['remainingHours'] = remainingHours;
                }
            } else {
                $state.go('home.home-index');
            }
        });

        $scope.closeAlert = (index) => {
            store.set('showAlert', false);
        };

        $scope.goToRenewSubscription = () => {
            $state.go('unsubscription.renew-subscription');
        };
    }
}

export const UnsubscriptionIndexComponent: ng.IComponentOptions = {
    template: require('./unsubscription-index.html'),
    controller: UnsubscriptionIndexController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/unsubscription-index/unsubscription-index.ts